import type { API as MainAPI } from "@ca/api";
import type { API } from "@ca/sms-api";

import { treaty } from "@elysiajs/eden";

// Keep API imports type-only and onResponse inlined: a value import drags the Elysia server graph into the browser bundle.
const onResponse = async (response: Response) => {
	if (response.ok && response.headers.get("Content-Type")?.split(";")[0] === "application/json") {
		return response.json();
	}
};

export const client = treaty<API>(window.location.origin, {
	headers: {
		"x-classa-client": "sms-web",
	},
	onResponse,
});

/** Sessions are issued by the main Class A API; use this client for auth only. */
export const authClient = treaty<MainAPI>(window.location.origin, {
	headers: {
		"x-classa-client": "sms-web",
	},
	onResponse,
});
